import { ComponentProps } from 'react'

import { BlockIcon } from '@/components/icons/block-icon'

import ChevronDownIconAsset from './chevron-down-icon.svg'

export const ChevronDownIcon = (props: Omit<ComponentProps<typeof BlockIcon>, 'icon'>) => {
	return <BlockIcon icon={ChevronDownIconAsset} {...props} />
}
